<form autocomplete="off" [name]="formName" [id]="formName" [formGroup]="formControl"
    (ngSubmit)="handleFormSubmit($event)">

    <shared-forms-input [compact]="compact" [parentForm]="formControl" name="memberCardNumber"
        [label]="labelAccountNumber">
    </shared-forms-input>

    <shared-forms-input [compact]="compact" [placeholder]="placeholderEmail" [parentForm]="formControl" name="email"
        [label]="labelEmail" [errors]="error$ | async" type="email" (onButtonClick)="handleErrorButtonClick($event)">
    </shared-forms-input>

    <ng-template #left>
        <shared-link [emphasis]="emphasis" (onClick)="handleSkipClick($event)">
            Don't have an account? Skip
        </shared-link>
    </ng-template>

    <ng-template #right>
        <shared-forms-submit [loading]="loading$ | async" marginTop="none" width="normal" [parentForm]="formControl">
            {{labelSubmit}}
        </shared-forms-submit>
    </ng-template>

    <shared-forms-offset-wrapper [topOffset]="modal" [modalOffset]="modal" [left]="left" [right]="right">
    </shared-forms-offset-wrapper>
</form>